import React, {useState} from 'react';
import {BASE_URL} from "../../Config/SharedConfig";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Switch} from "@mui/material";
import "swiper/css";
import 'swiper/css/pagination';
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import Agent from "../../Network/Agent";
import ToolBar from "../../Components/Elements/ToolBar";
import BottomSheetConfirm from "../../Components/Elements/BottomSheet/BottomSheetConfirm";


const ShowOwnerMode = () => {
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const queryClient = useQueryClient();

    const params = useParams()
    const productCode = params.arg
    const navigate = useNavigate()

    const invalidateProducts = () => {
        queryClient.invalidateQueries({
            queryKey: ['product', productCode],
            exact: true
        })
        queryClient.invalidateQueries({
            queryKey: ['products'],
            exact: false
        })
    }

    const {data: product, isLoading} = useQuery({
        queryKey: ['product', productCode],
        queryFn: async () => {
            try {
                const response = await Agent.Product.getProduct(productCode)
                const {product} = response.data.result
                if(!product?.isOwner) {
                    navigate(getGeneratedRoute(RouteEnumFinal.PRODUCT_SHOW_URL_GENERATE , productCode))
                }
                return product;
            } catch (error) {
                console.error('Error fetching Product:', error);
                throw error;
            }
        }
    })
    const mutateIsActive = useMutation({
        mutationFn: async () => {
            return Agent.Product.updateIsActive(productCode);
        },
        onSuccess: (data) => {
            invalidateProducts()
        },
        onError: (error) => {
            console.error('Error updating isActive:', error);
        },
    });
    const mutateIsForShow = useMutation({
        mutationFn: async () => {
            return Agent.Product.updateIsForShow(productCode);
        },
        onSuccess: (data) => {
            invalidateProducts()
        },
        onError: (error) => {
            console.error('Error updating isActive:', error);
        },
    });

    const toggleIsActive = () => {
        mutateIsActive.mutate()
    }
    const toggleIsForShow = () => {
        mutateIsForShow.mutate()
    }
    const onBottomSheetConfirmDeleteCallBack = (type , data) => {
        if (type === 'positive') {
            setIsDeleting(true)
            Agent.Product.delete(data)
                .then(response => {
                    setIsDeleting(false)
                    setIsModalDeleteOpen(false)
                    navigate("/all")
                })
                .catch(error => {
                    console.log(error.response)
                    setIsDeleting(false)
                })
        }
        if (type === 'negative') {
            setIsModalDeleteOpen(false)
        }
    }

    // if (!product?.isOwner) return null;
    if (isLoading) return (
        <div className='shimmer-container'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='square-box shimmer mt-48'/>
                    </div>
                    <div className='col-12'>
                        <div className='line-title shimmer mt-56'/>
                        <div className='line-paragraph shimmer mt-12'/>
                    </div>
                </div>
            </div>
        </div>
    )
    return (
        <>
            <ToolBar title={''} navigate={() => navigate(-1)} />

            <div className='container'>
                <div className='row'>
                    <div className='col-4'>
                        <div className='square-box'>
                            <div className='img-cnt-filled border-radius-12px'>
                                <img src={BASE_URL+product?.thumbnail?.internalPath} alt="product"/>
                            </div>
                        </div>
                    </div>
                    <div className='col-8'>
                        <div className='mobile-h4 cl-black'>
                            { product?.title }
                        </div>
                        <div className='mobile-body-1-regular cl-black mt-12'>
                            { product?.description }
                        </div>
                    </div>
                </div>
            </div>

            <div className='divider-12px bg-gray-custom-1 mt-20'/>

            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <Link to={getGeneratedRoute(RouteEnumFinal.PRODUCT_EDIT_URL_GENERATE , productCode)}
                              className='d-flex align-items-center justify-content-between td-none pt-12 pb-12'>
                            <div className=''>
                                <div className='mobile-subtitle-strong cl-black'>
                                    ویرایش مشخصات
                                </div>
                                <div className='mobile-body-1-regular cl-black mt-custom-4'>
                                    ویرایش مشخصات
                                </div>
                            </div>
                            <div className='img-cnt-24'>
                                <img src={"/assets/images/vectors/arrow_left_gray.svg"} alt="edit" />
                            </div>
                        </Link>
                    </div>
                    <div className='col-12'>
                        <Link to={getGeneratedRoute(RouteEnumFinal.PRODUCT_GALLERY_URL_GENERATE , productCode)}
                              className='d-flex align-items-center justify-content-between td-none pt-12 pb-12'>
                            <div className=''>
                                <div className='mobile-subtitle-strong cl-black'>
                                    مدیریت گالری
                                </div>
                                <div className='mobile-body-1-regular cl-black mt-custom-4'>
                                    ویرایش مشخصات
                                </div>
                            </div>
                            <div className='img-cnt-24'>
                                <img src={"/assets/images/vectors/arrow_left_gray.svg"} alt="gallery" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            <div className='divider-12px bg-gray-custom-1'/>

            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between pt-12 pb-12'>
                            <div className=''>
                                <div className='mobile-subtitle-strong cl-black'>
                                    فعال
                                </div>
                                <div className='mobile-body-1-regular cl-black mt-custom-4'>
                                    ویرایش مشخصات
                                </div>
                            </div>
                            <div>
                                <Switch checked={product?.isActive}
                                        onChange={toggleIsActive}
                                        inputProps={{ 'aria-label': 'controlled' }} />
                            </div>
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between pt-12 pb-12'>
                            <div className=''>
                                <div className='mobile-subtitle-strong cl-black'>
                                    موجود
                                </div>
                                <div className='mobile-body-1-regular cl-black mt-custom-4'>
                                    ویرایش مشخصات
                                </div>
                            </div>
                            <div>
                                <Switch checked={product?.isForShow}
                                        onChange={toggleIsForShow}
                                        inputProps={{ 'aria-label': 'controlled' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='divider-12px bg-gray-custom-1'/>

            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='pt-12 pb-12 cursor-pointer'
                             onClick={() => setIsModalDeleteOpen(m => !m)}>
                            <div className='mobile-subtitle-strong cl-tomato'>
                                حذف محصول
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/*<BottomSheetAction show={this.state.modal.actions}
                               onHide={this.toggleModal('actions')}
                               data={this.state.underConstructionFileCode}
                               buttons={[
                                   ActionButtonsEnum.DELETE ,
                               ]}
                               action={this.onBottomSheetCallBack} />*/}


            <BottomSheetConfirm show={isModalDeleteOpen}
                                onHide={() => setIsModalDeleteOpen(m => !m)}
                                title={"حذف عکس "}
                                body='آیا از حذف این عکس اطمینان دارید ؟'
                                data={productCode}
                                action={onBottomSheetConfirmDeleteCallBack}
                                isLoading={isDeleting}
                                btnText='حذف' />

        </>
    );
}


export default ShowOwnerMode